<app-map-control-container [position]="position">
  <button class="map-control-btn" (click)="onToggleFullscreenPressed()">
    <i [class.icon-expand]="!isExpanded()" [class.icon-collapse]="isExpanded()"></i>
  </button>
</app-map-control-container>
